<template>
    <module-card :nextFunction="unlockResources">
        <p><strong>HIV is no longer thought of as a “death sentence.” Anti-HIV medications, also known as anti-retroviral treatment (ART), have helped many people live with HIV for years, often even decades.</strong></p>
        <p>
            HIV copies itself very quickly inside the body after infection to attack the many disease-fighting cells in our immune system. HIV treatment works by slowing down or stopping the virus from copying itself. This makes it possible
            for HIV-positive people to feel healthier, and it makes HIV-positive people less able to pass on the virus than they would be without treatment.
        </p>
        <p>
            More information about how HIV treatment helps people live longer lives can be found here:
            <external-link href="https://www.cdc.gov/VitalSigns/hiv-aids-medical-care/infographic.html" target="blank">https://www.cdc.gov/VitalSigns/hiv-aids-medical-care/infographic.html</external-link>
        </p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'HIV' && o.topic === 'Living with HIV') {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
